import PlacesAutocomplete from "stimulus-places-autocomplete"

export default class extends PlacesAutocomplete {
  static targets = [
    ...PlacesAutocomplete.targets,
    "fullAddress",
    "streetAddress"
  ]

  placeChanged() {
    super.placeChanged();
    this.addressTarget.form.requestSubmit();
  }

  setAddressComponents(address) {
    super.setAddressComponents(address)
    if (this.hasStreetAddressTarget && address.street_number && address.route) {
      this.streetAddressTarget.value = `${address.street_number} ${address.route}`;
    }
    
    if (this.hasFullAddressTarget) this.fullAddressTarget.value = this.place.formatted_address || ""
  }

  get autocompleteOptions() {
    return {
      fields: ["formatted_address", "address_components", "geometry"],
      componentRestrictions: { country: this.countryValue }
    }
  }
}